import { render, staticRenderFns } from "./ORCImage.vue?vue&type=template&id=5f848a71&scoped=true"
import script from "./ORCImage.vue?vue&type=script&lang=js"
export * from "./ORCImage.vue?vue&type=script&lang=js"
import style0 from "./ORCImage.vue?vue&type=style&index=0&id=5f848a71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f848a71",
  null
  
)

export default component.exports